import { useParams } from "react-router-dom";

import { EmptyProjectManagementBoard } from "@/features/project-management";
import {
  ChaterUnacceptedProjectManagementBoard,
  ProjectManagementBoardWithData,
} from "@/features/project-management/project-management-board";
import { useAssessmentQuery, useWorkGroupQuery } from "@/generated/graphql";

export function ProjectManagementPage() {
  const { assessmentId = "" } = useParams();

  // fetch assessment data for settings
  const { data: assessmentData } = useAssessmentQuery({
    variables: { assessmentId },
  });
  const { data: workGroupData } = useWorkGroupQuery({
    variables: { assessmentId },
  });

  const assessment = assessmentData?.assessment ?? null;
  const group = workGroupData?.studentWorkGroup?.group ?? null;

  // render an empty taskboard when
  // we are missing the assessment settings or group data
  if (!assessment?.settings || !group) {
    return <EmptyProjectManagementBoard />;
  }

  // Charter is usable when enabled AND a form is published (server-derived
  // `groupCharterAvailable`). Milestones come from the charter, so the board is
  // tasks-only without one; the unaccepted-board screen shows until this member
  // accepts.
  const charterAvailable = assessment.settings.groupCharterAvailable;

  if (
    charterAvailable &&
    !workGroupData?.studentWorkGroup?.charter?.latestAgreement
  ) {
    return <ChaterUnacceptedProjectManagementBoard />;
  }

  return (
    <ProjectManagementBoardWithData
      group={group}
      assessmentSettings={assessment.settings}
      charterAvailable={charterAvailable}
    />
  );
}
